import Recording from '../../types/enums/recording';
import { Observable } from 'rxjs';
import {
  finishedRecordingsRequest,
  identifierRecordingsRequest,
  pendingRecordingsRequest,
} from './recordingsRequest';

function recordingsObservable(
  finished = true,
  pending = true,
  identifiers = true
) {
  return new Observable((subscriber) => {
    const requests = [];
    if (finished) {
      const finishedRecordings = finishedRecordingsRequest()
        .then((finishedRecordings) => {
          subscriber.next({
            data: finishedRecordings,
            type: Recording.Finished,
          });
        })
        .catch(() => {
          subscriber.error();
        });
      requests.push(finishedRecordings);
    }

    if (pending) {
      const pendingRecordings = pendingRecordingsRequest()
        .then((pendingRecordings) => {
          subscriber.next({ data: pendingRecordings, type: Recording.Pending });
        })
        .catch(() => {
          subscriber.error();
        });
      requests.push(pendingRecordings);
    }

    if (identifiers) {
      const recordingIdentifiers = identifierRecordingsRequest()
        .then((identifiers) => {
          subscriber.next({ data: identifiers, type: Recording.Identifier });
        })
        .catch(() => {
          subscriber.error();
        });
      requests.push(recordingIdentifiers);
    }

    Promise.allSettled(requests).then(() => {
      subscriber.complete();
    });
  });
}

export default recordingsObservable;
